import { DateTime } from "luxon";
import type { DateBounds } from "../types";
import { normalizeDateRange } from "./normalizeDateRange";

export function boundsFromMonths(
  startMonth?: Date,
  endMonth?: Date,
): DateBounds {
  if (startMonth && endMonth) {
    const { from: earlier, to: later } = normalizeDateRange(
      startMonth,
      endMonth,
    );
    return {
      min: DateTime.fromJSDate(earlier).startOf("month").toJSDate(),
      max: DateTime.fromJSDate(later).endOf("month").toJSDate(),
    };
  }
  const min = startMonth
    ? DateTime.fromJSDate(startMonth).startOf("month").toJSDate()
    : undefined;
  const max = endMonth
    ? DateTime.fromJSDate(endMonth).endOf("month").toJSDate()
    : undefined;
  return { min, max };
}
